<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouveau commercial"
  (primaryClick)="openCreate(commercialModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Commercial</th>
          <th>Entrepôt associé</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="3">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading">
          <td>{{ commercialLabel(row) }}</td>
          <td>{{ entrepotLabel(row) }}</td>
          <td class="d-flex align-items-center flex-nowrap">
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Modifier"
              (click)="openEdit(row, commercialModal)"
            >
              <i data-feather="edit" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-danger"
              title="Supprimer"
              (click)="deleteRow(row)"
            >
              <i data-feather="trash-2" [size]="16"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="3">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #commercialModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} commercial</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" [formGroup]="form">
    <div class="form-group">
      <label>Prénom</label>
      <input class="form-control" formControlName="prenom" />
    </div>
    <div class="form-group">
      <label>Nom</label>
      <input class="form-control" formControlName="nom" />
    </div>
    <div class="form-group mb-0">
      <label>Entrepôt associé</label>
      <ng-select
        [items]="entrepotOptions"
        bindLabel="label"
        bindValue="id"
        formControlName="entrepot_id"
        placeholder="Choisir un entrepôt"
        [clearable]="false"
      ></ng-select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">
      Enregistrer
    </button>
  </div>
</ng-template>
